export default "__VITE_ASSET__4eb7b75d__"